// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/router'
import store from './store/store.js'
import './store/filter'
import './assets/css/common.css';
import ViewUI from 'view-design';
import untils from './store/untils'
import 'view-design/dist/styles/iview.css';

import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts

// 工具
import tool from './assets/js/tool.js';
Vue.prototype.$tool = tool;

// 图片查看器
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)

Vue.use(ViewUI);
Vue.prototype.untils = untils
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js